// extracted by mini-css-extract-plugin
module.exports = {"main":"local-removals-module--main--3G2od"};